module.exports = __webpack_public_path__ + "images/partner3.03c98952.svg";